import { defineComponent as _defineComponent } from 'vue'
import BGLogoDesktop from '@/assets/img/landingpage-switch/Frame Logo Desktop.webp';
import BGLogoTablet from '@/assets/img/landingpage-switch/Frame Logo Tablet.webp';
import BGLogoSmartphone from '@/assets/img/landingpage-switch/Frame Logo Smartphone.webp';
import BGPeopleDesktop from '@/assets/img/landingpage-switch/Frame People Desktop.webp';
import BGPeopleTablet from '@/assets/img/landingpage-switch/Frame People Tablet.webp';
import BGPeopleSmartphone from '@/assets/img/landingpage-switch/Frame People Smartphone.webp';
import BCLogoCirclesOnly from '@/components/svg/logo/logo-circles-only.svg?inline';
import LPBgImage from '@/views/public/landingpage/components/LPBgImage.vue';
import usePublicPageBackgrounds from '@/mixins/usePublicPageBackgrounds';
import useResponsiveness from '@/mixins/useResponsiveness';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import TeamGrid from './components/TeamGrid.vue';
import TextOnlyTeam from './components/TextOnlyTeam.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

const bgsLogo: [string, string, string] = [BGLogoDesktop, BGLogoTablet, BGLogoSmartphone];
const bgsPeople: [string, string, string] = [BGPeopleDesktop, BGPeopleTablet, BGPeopleSmartphone];

const { getResponsiveImage } = usePublicPageBackgrounds();
const { isSmartphoneWidth } = useResponsiveness();

const bgLogo = getResponsiveImage(bgsLogo);
const bgPeople = getResponsiveImage(bgsPeople);

return { __sfc: true,bgsLogo, bgsPeople, getResponsiveImage, isSmartphoneWidth, bgLogo, bgPeople, BCLogoCirclesOnly, LPBgImage, BCXMarkdown, TeamGrid, TextOnlyTeam }
}

})